// extracted by mini-css-extract-plugin
module.exports = {"buttonPickerColor":"styles_buttonPickerColor__fMT1s","picker":"styles_picker__1zeCf","overlay":"styles_overlay__3FoEZ"};